import { LayaEnv } from "../../../../LayaEnv";
import { BufferTargetType, BufferUsage } from "../../../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../../../RenderEngine/RenderEnum/DrawType";
import { RenderClearFlag } from "../../../RenderEngine/RenderEnum/RenderClearFlag";
import { MeshTopology } from "../../../RenderEngine/RenderEnum/RenderPologyMode";
import { Shader3D, ShaderFeatureType } from "../../../RenderEngine/RenderShader/Shader3D";
import { SubShader } from "../../../RenderEngine/RenderShader/SubShader";
import { VertexDeclaration } from "../../../RenderEngine/VertexDeclaration";
import { LayaGL } from "../../../layagl/LayaGL";
import { StatElement } from "../../../layagl/StatisticsContext";
import { Color } from "../../../maths/Color";
import { Vector3 } from "../../../maths/Vector3";
import { VertexElement } from "../../../renders/VertexElement";
import { VertexElementFormat } from "../../../renders/VertexElementFormat";
import { ShaderDataType } from "../../DriverDesign/RenderDevice/ShaderData";
import { RenderState } from "../../RenderModuleData/Design/RenderState";
import { WebGLEngine } from "../RenderDevice/WebGLEngine";
import { WebGLVertexBuffer } from "../RenderDevice/WebGLVertexBuffer";
export class WebglRenderContext2D {
    constructor() {
        this._clearColor = new Color(0, 0, 0, 0);
        this.invertY = false;
        this.pipelineMode = "Forward";
        this._globalConfigShaderData = Shader3D._configDefineValues;
        if (LayaEnv.isConch && !WebglRenderContext2D.isCreateBlitScreenELement) {
            (!WebglRenderContext2D.isCreateBlitScreenELement) && this.setBlitScreenElement();
            WebglRenderContext2D.blitContext = new WebglRenderContext2D();
            let engine = LayaGL.renderEngine;
            engine.on("endFrame", () => {
                let last_main_frame_buffer = WebGLEngine._lastFrameBuffer_WebGLOBJ;
                let last_main_frame = WebGLEngine._lastFrameBuffer;
                WebGLEngine._lastFrameBuffer_WebGLOBJ = null;
                WebGLEngine._lastFrameBuffer = null;
                WebglRenderContext2D.blitContext.setOffscreenView(engine.getInnerWidth(), engine.getInnerHeight());
                WebglRenderContext2D.blitContext.setRenderTarget(null, true, Color.BLACK);
                WebglRenderContext2D.blitScreenElement.materialShaderData._setInternalTexture(Shader3D.propertyNameToID("u_MainTex"), last_main_frame._textures[0]);
                WebglRenderContext2D.blitContext.drawRenderElementOne(WebglRenderContext2D.blitScreenElement);
                WebGLEngine._lastFrameBuffer_WebGLOBJ = last_main_frame_buffer;
                WebGLEngine._lastFrameBuffer = last_main_frame;
                WebGLEngine.instance.getTextureContext().bindRenderTarget(last_main_frame);
            });
        }
    }
    setBlitScreenElement() {
        let blitScreenElement = LayaGL.render2DRenderPassFactory.createRenderElement2D();
        let shaderData = LayaGL.renderDeviceFactory.createShaderData();
        let _vertices = new Float32Array([
            1, 1, 1, 1,
            1, -1, 1, 0,
            -1, 1, 0, 1,
            -1, -1, 0, 0
        ]);
        let _vertexBuffer = new WebGLVertexBuffer(BufferTargetType.ARRAY_BUFFER, BufferUsage.Dynamic);
        _vertexBuffer.setDataLength(64);
        _vertexBuffer.setData(_vertices.buffer, 0, 0, _vertices.buffer.byteLength);
        let declaration = new VertexDeclaration(16, [new VertexElement(0, VertexElementFormat.Vector4, 0)]);
        _vertexBuffer.vertexDeclaration = declaration;
        let geometry = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.TriangleStrip, DrawType.DrawArray);
        geometry.setDrawArrayParams(0, 4);
        let bufferState = LayaGL.renderDeviceFactory.createBufferState();
        bufferState.applyState([_vertexBuffer], null);
        geometry.bufferState = bufferState;
        let attributeMap = {
            'a_PositionTexcoord': [0, ShaderDataType.Vector4]
        };
        let uniformMap = {
            "u_MainTex": ShaderDataType.Texture2D,
        };
        let shader = Shader3D.add("GLESblitScreen", false, false);
        shader.shaderType = ShaderFeatureType.DEFAULT;
        let subShader = new SubShader(attributeMap, uniformMap, {});
        shader.addSubShader(subShader);
        let vs = `
            #define SHADER_NAME GLESblitScreenVS

            varying vec2 v_Texcoord0;

            void main()
            {
                gl_Position = vec4(- 1.0 + (a_PositionTexcoord.x + 1.0), (1.0 - ((- 1.0 + (-a_PositionTexcoord.y + 1.0)) + 1.0) / 2.0) * 2.0 - 1.0, 0.0, 1.0);

                v_Texcoord0 = a_PositionTexcoord.zw;
            }
        `;
        let fs = `
            #define SHADER_NAME GLESblitScreenFS

            #include "Color.glsl";

            varying vec2 v_Texcoord0;

            void main()
            {
                vec4 mainColor = texture2D(u_MainTex, v_Texcoord0);
               
                gl_FragColor = mainColor;
            }
        `;
        let pass = subShader.addShaderPass(vs, fs);
        pass.statefirst = true;
        let blitState = pass.renderState;
        blitState.depthTest = RenderState.DEPTHTEST_ALWAYS;
        blitState.depthWrite = false;
        blitState.cull = RenderState.CULL_NONE;
        blitState.blend = RenderState.BLEND_DISABLE;
        blitState.stencilRef = 1;
        blitState.stencilTest = RenderState.STENCILTEST_OFF;
        blitState.stencilWrite = false;
        blitState.stencilOp = new Vector3(RenderState.STENCILOP_KEEP, RenderState.STENCILOP_KEEP, RenderState.STENCILOP_REPLACE);
        blitScreenElement.geometry = geometry;
        blitScreenElement.materialShaderData = shaderData;
        blitScreenElement.subShader = subShader;
        blitScreenElement.renderStateIsBySprite = false;
        WebglRenderContext2D.isCreateBlitScreenELement = true;
        WebglRenderContext2D.blitScreenElement = blitScreenElement;
    }
    drawRenderElementList(list) {
        for (var i = 0, n = list.length; i < n; i++) {
            let element = list.elements[i];
            element._prepare(this);
        }
        for (var i = 0, n = list.length; i < n; i++) {
            let element = list.elements[i];
            element._render(this);
        }
        LayaGL.statAgent.recordCTData(StatElement.CT_2DDrawCall, list.length);
        LayaGL.renderEngine._framePassCount++;
        return 0;
    }
    setOffscreenView(width, height) {
        this._offscreenWidth = width;
        this._offscreenHeight = height;
    }
    setRenderTarget(value, clear, clearColor) {
        this._destRT = value;
        clearColor.cloneTo(this._clearColor);
        if (this._destRT) {
            WebGLEngine.instance.getTextureContext().bindRenderTarget(this._destRT);
            WebGLEngine.instance.viewport(0, 0, this._destRT._textures[0].width, this._destRT._textures[0].height);
        }
        else {
            WebGLEngine.instance.getTextureContext().bindoutScreenTarget();
            WebGLEngine.instance.viewport(0, 0, this._offscreenWidth, this._offscreenHeight);
        }
        WebGLEngine.instance.scissorTest(false);
        WebGLEngine.instance.clearRenderTexture(clear ? RenderClearFlag.Color : RenderClearFlag.Nothing, this._clearColor);
    }
    getRenderTarget() {
        return this._destRT;
    }
    drawRenderElementOne(node) {
        node._prepare(this);
        node._render(this);
        LayaGL.statAgent.recordCTData(StatElement.CT_2DDrawCall, 1);
        LayaGL.renderEngine._framePassCount++;
    }
    runOneCMD(cmd) {
        cmd.apply(this);
    }
    runCMDList(cmds) {
        cmds.forEach(element => {
            element.apply(this);
        });
    }
}
WebglRenderContext2D.isCreateBlitScreenELement = false;
